import React from 'react';
import { Box } from '@mafc/trolly';

interface Props {
  [K: string]: any;
}
const ExtendedWarrantyCaption: React.FC<Props> = props => <Box as="span" fontSize={1} {...props} />;

export default ExtendedWarrantyCaption;
